<app-header></app-header>
<app-page-title></app-page-title>

<div class="col-lg-12">
  <div class="row m-y">
    <div class="col-lg-3 d-flex-row">
      <div class="search-label">Start Date</div>
      <input autocomplete="off" pattern="^[^<>]*$" style="width: 100%;" type="text"
             placeholder="Start Date"
             class="form-control"
             #dp="bsDatepicker"
             bsDatepicker

             [maxDate]="maxStartDate"
             (bsValueChange)="onStartDateChange($event)">
      <timepicker  [showMeridian]="false" [(ngModel)]="startReportTime"></timepicker>

    </div>

    <div class="col-lg-3 d-flex-row">
      <div class="search-label">End Date</div>
      <input autocomplete="off" pattern="^[^<>]*$"  style="width: 100%;" type="text"
              placeholder="End Date"
              class="form-control"
              #dp="bsDatepicker"
              bsDatepicker

              [maxDate]="maxEndDate"
              (bsValueChange)="onEndDateChange($event)">
      <timepicker  [showMeridian]="false" [(ngModel)]="endReportTime"></timepicker>

    </div>
  </div>
  <div class="row">
    <div class="col-md-3 col-lg-1-5">
      <div class="search-label">Aggregation</div>
      <select [(ngModel)]="aggregationFilter" class="form-control">
        <!-- <option  value="">Aggregation</option> -->
        <option  value="1">Average</option>
        <option  value="2">Minimum</option>
        <option  value="3">Maximum </option>
      </select>
    </div>
    <div class="col-md-3 col-lg-1-5">
      <div class="search-label">Time Interval</div>
      <select [(ngModel)]="timeIntervalFilter" class="form-control">
        <option  *ngFor="let item of timeIntervalArray; index as i" value="{{i+1}}"> {{item}}</option>
      </select>
    </div>
    <div class="col-md-3 col-lg-2-5">
      <div class="search-label">Select Region</div>
      <select [(ngModel)]="regionFilter" class="form-control" (change) = "getCategoryList($event)">
        <option value="">All Region </option>
        <option *ngFor="let regionRow of regionList"  value="{{regionRow.region_name}}"> {{regionRow.region_name}} </option>
      </select>
    </div>
    <div class="col-md-3 col-lg-3-5">
      <div class="search-label">Category Type</div>
      <select [(ngModel)]="categoryFilter" class="form-control" (change) = "getTimeUnitList($event)">
        <option value="">All Category Type </option>
        <option *ngFor="let category of categoryList"  value="{{category.industry_category}}">{{category.industry_category}}</option>
      </select>
    </div>
    <div class="col-md-3 col-lg-4-5">
      <div class="search-label">Industry Type</div>
       <select [(ngModel)]="unitTypeFilter" class="form-control" (change) = "getVendorList($event)">
         <option value=""> All Industry Type </option>
        <option *ngFor="let item of timeUnitList"  value="{{item.stdunit}}"> {{item.stdunit}} </option>
      </select>
    </div>
    <div class="col-md-3 col-lg-4-5">
      <div class="search-label">Vendor</div>
      <select [(ngModel)]="vendorFilter" class="form-control" (change) = "getIndustryList($event)">
        <option value="">All Vendor</option>
        <option *ngFor="let vendor of vendorList"  value="{{vendor.id}}"> {{vendor.vendor_name}} </option>
      </select>
    </div>
    <div class="col-md-3 col-lg-4-5">
      <div class="search-label"> Industry</div>
      <!-- <select [(ngModel)]="industryFilter" class="form-control" (change) = "getStationList($event)">
        <option value=""> All Industry </option>
        <option *ngFor="let industry of industryList"  value="{{industry.id}}"> {{industry.name}} </option>
      </select> -->
      <ng-multiselect-dropdown
         class="form-control multi"
         [data]="industryList"
         [(ngModel)]="industryFilter"
         [settings]="industrySettings"
         (onSelect)="getStationList($event)"
         (onSelectAll)="getStationList($event,'all')"
         (onDeSelect)="getStationList($event)"
         >
      </ng-multiselect-dropdown>
    </div>
    <div class="col-md-3 col-lg-4-5">
      <div class="search-label">Station</div>
      <!-- <select [(ngModel)]="stationFilter" class="form-control">
        <option value=""> All Station </option>
        <option *ngFor="let station of stationList"  value="{{station.id}}"> {{station.name}} </option>
      </select> -->
      <ng-multiselect-dropdown
        class="form-control multi"
         [data]="stationList"
         [(ngModel)]="stationFilter"
         [settings]="stationSettings"
         >
        </ng-multiselect-dropdown>
    </div>
  </div>


  <div class="col-lg-12 center m-y">
    <button class="btn btn-primary" (click)="getExceededIndustry()" > <i class="icon icon-search4"></i> Search </button>
  </div>
</div>

<div class="page-container">

  <!-- Page content -->
  <div class="page-content">

    <!-- Main content -->
    <div class="content-wrapper">

      <div class="row">

        <div *ngIf="firstLevelExceedance" class="panel panel-flat">
          <div class="panel-body">
            <div class="col-md-9 h5 text-justify" style="padding-left: 0;">
              <span>Delay Monitoring Abstract Report of OCEMS
                {{regionFilter?("of "+regionFilter):""}}
                {{  unitTypeFilter?( "," +unitTypeFilter | titlecase):""}}
              for the period from  {{this.start_date}}
            To {{this.end_date}}
            {{timeIntervalFilter?("for time interval "+ timeIntervalArray[timeIntervalFilter-1]):""}}.</span>
              <!--<span style="margin-left: 30px; font-weight: 500; font-size: 10px;" class="text-muted">20/06/2018 - 17-07-2018</span>-->
              </div>

            <div class=" col-md-3" style="text-align: right;" >
              <button style="margin-right: 10px; cursor: pointer !important;" type="button" class="btn btn-xs btn-info"><strong>Total Regions </strong>  <span class="badge badge-info">{{firstLevelExceedance.length}}</span></button>
             <a title="Export Excel." (click)="exportReportFirstLevel('excel')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                <i class="icon icon-file-excel"></i>
              </a>
              <a id="exportexcelhrefFirstLevel" target="_blank"></a>&nbsp;
              <!-- <a title="Export PDF." (click)="exportReportFirstLevel('pdf')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                <i class="icon icon-file-pdf"></i>
              </a>
              <a id="exportpdfhrefFirstLevel" target="_blank"></a> -->

            </div>

          </div>

          <table *ngIf="!regionLoaderExceedance" class="table datatable-show-all">
            <thead>
            <tr>
              <th>Region Name</th>
              <th>Name of Officer</th>
              <th>Number of station in region</th>
              <th>Number of units delay their stations</th>
              <th>Delay Hours</th>
              <th>Detail</th>

            </tr>
            </thead>

            <tbody>
            <tr *ngFor="let region of firstLevelExceedance">
              <td>{{region.region_name}}</td>
              <td>{{region.officer_name}}</td>
              <td>{{region.total_stations}}</td>
              <td>{{region.total_inactive_stations}}</td>
              <td>{{region.hours_inactive ? region.hours_inactive : ""}}</td>
              <td>
                <a *ngIf="region.total_inactive_stations" (click)="getExceedanceIndustryList(region.inactive_station_ids)" data-toggle="modal" data-target="#secondLevel">View</a>
              </td>
            </tr>
            <tr>
              <td colspan="2">Total</td>
              <td *ngIf="locationsSum()>0"> <a (click)="getStationIDs('total_station_ids', 'total')"> {{ locationsSum() }}</a></td>
              <td *ngIf="locationsSum()<=0"> {{ locationsSum() }}</td>
              <td *ngIf="locationsExceededSum()>0"> <a (click)="getStationIDs('inactive_station_ids', 'delay')"> {{ locationsExceededSum() }}</a></td>
              <td *ngIf="locationsExceededSum()<=0"> {{ locationsExceededSum() }}</td>
              <td><button id="openModalButton" [hidden]="true" data-toggle="modal" data-target="#secondLevel">Open Modal</button></td>
              <td></td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="regionLoaderExceedance">
            <div colspan="12" class="col-lg-12 text-center" style="height: 180px;">
              <div style="margin-top: 50px;">
                <img src="/assets/images/load.gif" />
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!regionLoader && (!firstLevelExceedance)"  class="col-lg-12 text-center" style="height: 180px;">
          <div style="font-size: 28px; font-weight: 600; color: red; margin-top: 50px;">
            No Industry Station Report Found
          </div>
        </div>

        <div id="secondLevel" class="modal fade" role="dialog">
          <div class="modal-dialog">

            <!-- Modal content-->
            <div class="modal-content">

              <div class="modal-header">
                <div  *ngIf="!moreDetailDrilledExceedance" class="panel-body">
                  <div class="col-md-10 h5 text-justify" style="padding-left: 0;">
                    <span>Delay Monitoring Abstract details Report of OCEMS
                      {{regionFilter?("of "+regionFilter):""}}
                      {{  unitTypeFilter?( "," +unitTypeFilter | titlecase):""}}
                      for the period from  {{this.start_date}}
                      To {{this.end_date}}
                      {{timeIntervalFilter?("for time interval "+ timeIntervalArray[timeIntervalFilter-1]):""}}
                      .</span>
                  </div>

                  <div class=" col-md-2" style="text-align: right;" >
                    <a title="Export Excel." (click)="exportReportSecondLevel('excel')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                      <i class="icon icon-file-excel"></i>
                    </a>
                    <a id="exportexcelhrefSecondLevel" target="_blank"></a>&nbsp;
                    <!-- <a title="Export PDF." (click)="exportReportSecondLevel('pdf')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                         <i class="icon icon-file-pdf"></i>
                    </a>
                    <a id="exportpdfhrefSecondLevel" target="_blank"></a> -->
                    <button type="button" class="closeModal" data-dismiss="modal">&times;</button>
                  </div>
                </div>

              </div>

              <div class="modal-body">
                <div *ngIf="!moreDetailDrilledExceedance">
                  <table class="table datatable-show-all">
                    <thead>
                    <tr>
                      <th>HROCMMs ID</th>
                      <th>Industry name</th>
                      <th>Industry address</th>
                      <th>Region</th>
                      <th> Category Type</th>
                      <th>Name of station delay</th>
                      <th>Station delay count</th>
                      <th>Count of delay as per protocol</th>
                      <th> Type of alert generate</th>
                      <th> Details</th>
                    </tr>
                    </thead>

                    <tbody *ngIf="!industryLoaderExceedance  && !oldFormat">
                    <tr *ngFor="let industry of secondLevelExceedance">
                      <td>{{industry[0][0]['hr_ocmms_id']}}</td>
                      <td>{{industry[0][0]['industry_name']}}</td>
                      <td>{{industry[0][0]['industry_address']}}</td>
                      <td>{{industry[0][0]['region_name']}}</td>
                      <td>{{industry[0][0]['industry_category']}}</td>

                      <td>
                        <span *ngFor="let station of industry">
                          {{station[0]['station_name']}},
                        </span>
                      </td>
                      <td>{{industry.length}}</td>


                      <td>
                        <span>
                            {{SUM(industry)}}
                        </span>
                      </td>
                      <td>{{industry.alert_type}}</td>
                      <td>
                        <button (click)="getIndustryExceedanceHistory(industry)" class="btn btn-xs btn-primary"><i class="icon icon-more2"></i> </button>
                      </td>
                    </tr>
                    </tbody>
                    <tbody *ngIf="!industryLoaderExceedance  && oldFormat">
                    <tr *ngFor="let industry of secondLevelExceedance">
                      <td>{{industry.hr_ocmms_id}}</td>
                      <td>{{industry.industry_name}}</td>
                      <td>{{industry.industry_address}}</td>
                      <td>{{industry.region_name}}</td>
                      <td>{{industry.industry_category}}</td>
                      <td>{{industry.inactive_station_names}}</td>
                      <td>{{industry.total_inactive_stations}}</td>
                      <td>{{industry.hours_inactive}}</td>
                      <td>{{industry.alert_type}}</td>
                      <td>
                        <button (click)="getIndustryExceedanceHistory(industry)" class="btn btn-xs btn-primary"><i class="icon icon-more2"></i> </button>
                      </td>
                    </tr>
                    </tbody>
                    <tbody *ngIf="industryLoaderExceedance" >
                    <tr>
                      <td colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                        <div style="margin-top: 50px;">
                          <img src="/assets/images/load.gif" />
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div *ngIf="moreDetailDrilledExceedance">
                  <button (click)="backToPreviousLevelExceedance()" class="btn btn-xs btn-primary"><strong><i class="icon icon-arrow-left5"></i>Back</strong> </button>
                  <br>
                  <br>
                  <div class="row">

                    <div  class="panel panel-flat">
                      <div class="">
                        <div class="col-md-9 h5 text-justify" style="padding-left: 0;">
                          <span>Delay Monitoring Abstract details Report of OCEMS
                            {{regionFilter?("of "+regionFilter):""}}
                            {{  unitTypeFilter?( "," +unitTypeFilter | titlecase):""}}
                            for the period from  {{this.start_date}}
                            To {{this.end_date}}
                            {{timeIntervalFilter?("for time interval "+ timeIntervalArray[timeIntervalFilter-1]):""}}
                            .</span>
                          <!--<span style="margin-left: 30px; font-weight: 500; font-size: 10px;" class="text-muted">20/06/2018 - 17-07-2018</span>-->
                        </div>
                        <div class="col-md-3" style="text-align: right; margin-top:7px;" >
                          <ul class="icons-list">
                            <li>
                              <button style="margin-right: 10px; cursor: pointer !important;" type="button" class="btn btn-xs btn-info"><strong>Total Stations </strong>  <span class="badge badge-info">{{exceedanceIndustryHistory.length}}</span></button>
                            </li>

                            <li>
                              <a title="Export Excel." (click)="exportReport('excel')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                                <i class="icon icon-file-excel"></i>
                              </a>
                            </li>
                            <a id="exportexcelhref" target="_blank"></a>

                            <!-- <li>
                              <a title="Export PDF." (click)="exportReport('pdf')" style="background-color: #EEF3F6; font-weight: 900 !important; color: #000 !important; margin-right: 10px;" class="btn border-primary text-primary btn-flat btn-icon btn-rounded btn-sm">
                                <i class="icon icon-file-pdf"></i>
                              </a>
                              <a id="exportpdfhref" target="_blank"></a>
                            </li> -->

                          </ul>

                        </div>

                      </div>
                      <table class="table datatable-show-all">
                        <thead *ngIf="!oldFormat">
                        <tr>
                          <th colspan="2">HROCMMs ID</th>
                          <th>{{industryExceedanceHistoryData[0][0].hr_ocmms_id ? industryExceedanceHistoryData[0][0].hr_ocmms_id : ""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Industry name</th>
                          <th>{{industryExceedanceHistoryData[0][0].industry_name?industryExceedanceHistoryData[0][0].industry_name:""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Industry address</th>
                          <th>{{industryExceedanceHistoryData[0][0].industry_address?industryExceedanceHistoryData[0][0].industry_address:""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Category type & category</th>
                          <th>{{industryExceedanceHistoryData[0][0].industry_category?industryExceedanceHistoryData[0][0].industry_category:""}}
                            {{ industryExceedanceHistoryData[0][0].industry_type ? "("+industryExceedanceHistoryData[0][0].industry_type+")" : (unitTypeFilter?(" " +unitTypeFilter):"")}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Regional office</th>
                          <th>{{industryExceedanceHistoryData[0][0].region_name?industryExceedanceHistoryData[0][0].region_name:""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Period & Time Duration</th>
                          <!--                          <th>{{otherDetails.start_date ? otherDetails.start_date:""}}</th>-->

                          <th *ngIf="this.start_date!=this.end_date">
                            {{this.start_date | date}}  - {{this.end_date | date}}
                            ({{timeIntervalFilter?(timeIntervalArray[timeIntervalFilter-1]):""}})
                          </th>
                          <!--                          <th *ngIf="cell['min_response_date_time']==cell['max_response_date_time']"><u>Response Date</u> <br><b>{{cell['max_response_date_time'] | date}} {{cell['max_response_date_time'] | date: 'shortTime'}}</b></th>-->

                        </tr>
                        <tr>
                          <th colspan="2">Current status of unit (online/offline/delay)</th>
                          <th>
                            <span id="industry_status" *ngIf="(industryExceedanceHistoryData[0][0].status_type) == 'delay'" class="label label-warning">{{industryExceedanceHistoryData[0][0].status_type}}</span>
                            <span id="industry_status" *ngIf="(industryExceedanceHistoryData[0][0].status_type) == 'online'" class="label label-success"><strong>{{industryExceedanceHistoryData[0][0].status_type}}</strong></span>
                            <span id="industry_status" *ngIf="(industryExceedanceHistoryData[0][0].status_type) == 'offline'" class="label label-danger">{{industryExceedanceHistoryData[0][0].status_type}}</span>
                          </th>
                        </tr>
                        <tr>
                          <th colspan="2">No of interval delay during period (count)</th>
                          <!--                            <th>{{industryExceedanceHistoryData.hours_inactive?industryExceedanceHistoryData.hours_inactive:""}}</th>-->
                          <th>{{SUM(industryExceedanceHistoryData)}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Type of alert generated</th>
                          <th>{{industryExceedanceHistoryData.alert_type?industryExceedanceHistoryData.alert_type:""}}</th>
                        </tr>
                        </thead>

                        <thead *ngIf="oldFormat">
                        <tr>
                          <th colspan="2">HROCMMs ID</th>
                          <th>{{industryExceedanceHistoryData.hr_ocmms_id ? industryExceedanceHistoryData.hr_ocmms_id : ""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Industry name</th>
                          <th>{{industryExceedanceHistoryData.industry_name?industryExceedanceHistoryData.industry_name:""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Industry address</th>
                          <th>{{industryExceedanceHistoryData.industry_address?industryExceedanceHistoryData.industry_address:""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Category type & category</th>
                          <th>{{industryExceedanceHistoryData.industry_category?industryExceedanceHistoryData.industry_category:""}}
                            {{ industryExceedanceHistoryData.industry_type ? "("+industryExceedanceHistoryData.industry_type+")" : (unitTypeFilter?(" " +unitTypeFilter):"")}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Regional office</th>
                          <th>{{industryExceedanceHistoryData.region_name?industryExceedanceHistoryData.region_name:""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Period & Time Duration</th>
                          <!--                          <th>{{otherDetails.start_date ? otherDetails.start_date:""}}</th>-->

                          <th *ngIf="this.start_date!=this.end_date">
                            {{this.start_date | date}}  - {{this.end_date | date}}
                            ({{timeIntervalFilter?(timeIntervalArray[timeIntervalFilter-1]):""}})
                          </th>
                          <!--                          <th *ngIf="cell['min_response_date_time']==cell['max_response_date_time']"><u>Response Date</u> <br><b>{{cell['max_response_date_time'] | date}} {{cell['max_response_date_time'] | date: 'shortTime'}}</b></th>-->

                        </tr>
                        <tr>
                          <th colspan="2">Current status of unit (online/offline/delay)</th>
                          <th>
                            <span id="industry_status" *ngIf="(industryExceedanceHistoryData.status_type) == 'delay'" class="label label-warning">{{industryExceedanceHistoryData.status_type}}</span>
                            <span id="industry_status" *ngIf="(industryExceedanceHistoryData.status_type) == 'online'" class="label label-success"><strong>{{industryExceedanceHistoryData.status_type}}</strong></span>
                            <span id="industry_status" *ngIf="(industryExceedanceHistoryData.status_type) == 'offline'" class="label label-danger">{{industryExceedanceHistoryData.status_type}}</span>
                          </th>
                        </tr>
                        <tr>
                          <th colspan="2">No of interval delay during period (count)</th>
                          <th>{{industryExceedanceHistoryData.hours_inactive?industryExceedanceHistoryData.hours_inactive:""}}</th>
                        </tr>
                        <tr>
                          <th colspan="2">Type of alert generated</th>
                          <th>{{industryExceedanceHistoryData.alert_type?industryExceedanceHistoryData.alert_type:""}}</th>
                        </tr>
                        </thead>
                      </table>
                      <div class="table-responsive">
                        <table *ngIf="!historyLoaderExceedance">
                          <tbody *ngIf="!oldFormat">

                          <tr *ngIf="exceedanceIndustryHistory.length">
                            <th >
                              <div class="px-2" *ngFor="let char of ['St','ati','on','  ','na','me']">{{char}}</div>
                            </th>
                            <!--                            <th *ngFor="let int of exceedanceIndustryHistory; i as index" colspan="3">-->
                            <!--                              <div class="set-height"><b>{{int[0]['station_name']}}</b></div>-->
                            <!--                              <table>-->
                            <!--                                <thead>-->
                            <!--                                <tr colspan="3">-->
                            <!--                                  <th>-->
                            <!--                                    <table>-->
                            <!--                                      <thead>-->
                            <!--                                      <tr>-->
                            <!--                                        <th>-->
                            <!--                                          <u>Offline From</u><br>-->
                            <!--                                          <span *ngIf="int['inactive_from']">-->
                            <!--                                          <b>{{int['inactive_from'] | date}} {{int['inactive_from'] | date: 'shortTime'}}</b>-->
                            <!--                                          </span>-->
                            <!--                                        </th>-->
                            <!--                                        <th>-->
                            <!--                                          <u>Offline Till</u><br>-->
                            <!--                                          <span *ngIf="int['inactive_till']">-->
                            <!--                                          <b>{{int['inactive_till'] | date}} {{int['inactive_till'] | date: 'shortTime'}}</b>-->
                            <!--                                          </span>-->
                            <!--                                        </th>-->
                            <!--                                        <th><u>Hours</u><br><b>{{int['hours_inactive']}}</b></th>-->
                            <!--                                      </tr>-->
                            <!--                                      </thead>-->
                            <!--                                    </table>-->
                            <!--                                  </th>-->
                            <!--                                </tr>-->
                            <!--                                </thead>-->
                            <!--                              </table>-->
                            <!--                            </th>-->
                            <th *ngFor="let int of exceedanceIndustryHistory; i as index" colspan="3">
                              <div class="set-height"><b>{{int[0]['station_name'] | titlecase}}</b></div>
                              <table>
                                <thead>
                                <tr colspan="3">
                                  <th>
                                    <table>
                                      <thead>
                                      <tr>
                                        <th><u>Delay From</u></th>
                                        <th><u>Delay Till</u></th>
                                        <th><u>Hours</u></th>
                                      </tr>
                                      <tr  *ngFor="let cell of int">
                                        <th><b>{{cell['inactive_from'] | date}} {{cell['inactive_from'] | date : 'shortTime'}}</b></th>
                                        <th><b>{{cell['inactive_till'] | date}} {{cell['inactive_till'] | date : 'shortTime'}}</b></th>
                                        <th *ngIf="cell['hours_inactive']"><b>{{cell['hours_inactive']}}</b></th>
                                        <th *ngIf="!cell['hours_inactive']"><b>N/A</b></th>
                                      </tr>
                                      </thead>
                                    </table>
                                  </th>
                                </tr>
                                </thead>
                              </table>
                            </th>

                          </tr>

                          </tbody>

                          <tbody *ngIf="oldFormat">

                          <tr *ngIf="exceedanceIndustryHistory.length">
                            <th >
                              <div class="px-2" *ngFor="let char of ['St','ati','on','  ','na','me']">{{char}}</div>
                            </th>
                            <th *ngFor="let int of exceedanceIndustryHistory; i as index" colspan="3">
                              <div class="set-height"><b>{{int['station_name']}}</b></div>
                              <table>
                                <thead>
                                <tr colspan="3">
                                  <th>
                                    <table>
                                      <thead>
                                      <tr>
                                        <th>
                                          <u>Delay From</u><br>
                                          <span *ngIf="int['inactive_from']">
                                          <b>{{int['inactive_from'] | date}} {{int['inactive_from'] | date: 'shortTime'}}</b>
                                          </span>
                                        </th>
                                        <th>
                                          <u>Delay Till</u><br>
                                          <span *ngIf="int['inactive_till']">
                                          <b>{{int['inactive_till'] | date}} {{int['inactive_till'] | date: 'shortTime'}}</b>
                                          </span>
                                        </th>
                                        <th><u>Hours</u><br><b>{{int['hours_inactive']}}</b></th>
                                      </tr>
                                      </thead>
                                    </table>
                                  </th>
                                </tr>
                                </thead>
                              </table>
                            </th>
                          </tr>

                          </tbody>
                        </table>
                      </div>
                      <div *ngIf="historyLoaderExceedance">
                        <div colspan="12" class="col-lg-12 text-center" style="height: 180px;">
                          <div style="margin-top: 50px;">
                            <img src="/assets/images/load.gif" />
                          </div>
                        </div>
                      </div>
                    </div>



                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
